import { AnnexService } from 'src/app/services/AnnexService';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PopuppatientsearchComponent } from '../popuppatientsearch/popuppatientsearch.component';
import { formatDate } from '@angular/common';
import { Square } from 'src/app/services/Square';
import { AnnexModel } from 'src/app/models/AnnexModel';
import { PatientModel } from 'src/app/models/PatientsModel';
import Swal from 'sweetalert2';
import { DataBankService } from 'src/app/services/DataBankService';
import { LocalStorageService } from 'ngx-webstorage';
import { DatabankModel } from 'src/app/models/DataBankModel';

@Component({
  selector: 'app-annex',
  templateUrl: './annex.component.html',
  styleUrls: ['./annex.component.css'],
  styles: ['canvas { border-style: solid }']
})

export class AnnexComponent implements OnInit {
  @ViewChild('canvas', { static: true })
  canvas: ElementRef<HTMLCanvasElement>;
  private ctx: CanvasRenderingContext2D;
  currentdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  xCoordinate: number;
  yCoordinate: number;
  color = '';
  type = '0';
  patientCode = '';
  patientFName = '';
  notes = '';
  userId = 'sa';
  compCode = '1';
  modifaiedDate = '2021-01-01';
  AnnexListForPatient: AnnexModel[] = [];
  drawCircle(x, y, radius) { this.ctx.beginPath(); this.ctx.arc(x, y, radius, 0, Math.PI * 2); this.ctx.fill(); }
  constructor(private dialogref: MatDialog, public annexModel: AnnexModel, public storage: LocalStorageService,public annexService: AnnexService, public patientModel: PatientModel,public databankservice : DataBankService) { }

  ngOnInit(): void {
    this.ctx = this.canvas.nativeElement.getContext('2d') as unknown as CanvasRenderingContext2D;

    let image = new Image();
    this.ctx.lineWidth = 3;
    this.ctx.lineCap = 'round';
    this.ctx.strokeStyle = '#000';
    image.onload = () => {
      this.ctx.drawImage(image, 0, 0, 1019, 557);
    }
    image.src = "assets/images/Annex.jpg";

    this.patientCode = this.storage.retrieve('stgPatientCode');
    this.RetrivePatient();
  }

  openDialog() {
    const dialogRef = this.dialogref.open(PopuppatientsearchComponent,
      {
        data: {
          dataKey: this.patientModel
        }
      });
    dialogRef.afterClosed().subscribe(result => {
    });
    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.patientCode = result.patientCode;
        this.patientFName = result.patientFName;
        dialogSubmitSubscription.unsubscribe();
        this.getPatientAnnex();
      });
  }
  RetrivePatient(){
    this.databankservice.getPatient(this.patientCode,this.storage.retrieve('stgcompCode')).subscribe((data: DatabankModel) => {
      this.patientFName = data.patientFullName;
      this.getPatientAnnex();
  }

    )
  }
  getCursorPosition = (canvas, event) => {
    let rect = canvas.getBoundingClientRect();
    this.xCoordinate = Math.round(event.clientX - rect.left);
    this.yCoordinate = Math.round(event.clientY - rect.top);

  }
  toRedColor() {
    this.color = 'red';
  }
  toGreenColor() {
    this.color = 'green';
  }
  animate() {
    const canvas = document.querySelector('canvas')
    canvas.addEventListener('mousedown', (e) => {
      this.getCursorPosition(canvas, e)
    });
    if (this.color != '') {
      this.ctx.fillStyle = this.color;
      const square = new Square(this.ctx);
     // square.draw(this.xCoordinate / 10, this.yCoordinate / 10, 10);
     this.drawCircle(this.xCoordinate, this.yCoordinate, 5);
     if (this.color === 'red') {
        this.type = '0';
      } else if (this.color === 'green') {
        this.type = '1';
      }
      if (this.xCoordinate != null && this.yCoordinate != null) {
        this.AnnexListForPatient.push({ patientCode: this.patientCode, postionX: this.xCoordinate, postionY: this.yCoordinate, type: this.type, indexPic: '0', notes: this.notes, userID: this.userId, compCode: this.compCode, modifaiedDate: this.modifaiedDate });
      }
    }
  }
  getPatientAnnex() {
    this.ctx = this.canvas.nativeElement.getContext('2d') as unknown as CanvasRenderingContext2D;
    let image = new Image();
    this.ctx.lineWidth = 3;
    this.ctx.lineCap = 'round';
    this.ctx.strokeStyle = '#000';
    image.onload = () => {
      this.ctx.drawImage(image, 0, 0, 1019, 557);
    }
    image.src = "assets/images/Annex.jpg";
    this.annexService.getAnnexLookup(this.patientCode, this.compCode).subscribe(data => {
      for (let index = 0; index < data.length; index++) {
        const square = new Square(this.ctx);
        if (data[index].type === '0') {
          this.ctx.fillStyle = 'red';
          this.drawCircle(data[index].postionX , data[index].postionY, 5);

          //  square.draw(data[index].postionX / 10, data[index].postionY / 10, 10);
        } else if (data[index].type === '1') {
          this.ctx.fillStyle = 'green';
          this.drawCircle(data[index].postionX , data[index].postionY, 5);

          //   square.draw(data[index].postionX / 10, data[index].postionY / 10, 10);
        }
      }
    });
  }
  deletePatientAnnex() {
    this.annexService.deleteAnnex(this.patientCode, this.compCode).subscribe(data => {
    });
    this.ctx = this.canvas.nativeElement.getContext('2d') as unknown as CanvasRenderingContext2D;
    let image = new Image();
    this.ctx.lineWidth = 3;
    this.ctx.lineCap = 'round';
    this.ctx.strokeStyle = '#000';
    image.onload = () => {
      this.ctx.drawImage(image, 0, 0, 1019, 557);
    }
    image.src = "assets/images/Annex.jpg";
  }
  addPatientAnnex() {
    this.annexService.addAnnex(this.AnnexListForPatient).subscribe(data => {
      this.mesgSave();
    });
  }

  mesgDelete() {
    console.log('in msg delete');
    Swal({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(() => {
      this.deletePatientAnnex();
      Swal('Deleted!', 'Your record has been deleted.', 'success');

    },
      function (dismiss) {
        if (dismiss === 'cancel') {
          Swal('Cancelled', 'Your record is safe :)', 'error');
        }
      }
    );
  }
  mesgSave() {
    Swal({
      title: 'Your work has been saved',
      type: 'success',
      showConfirmButton: false,
      timer: 1500
    });
  }
}
